import { UserStateModel } from '../../../model';

export class SetUser {
  static readonly type = '[User] Set User';
  constructor(public payload: UserStateModel) {}
}

export class SetUserAsDICMember {
  static readonly type = '[User] Set User As DIC Member';
}

export class SetUserAsAdmin {
  static readonly type = '[User] Set User As Admin';
}
